import { Modal, Button } from 'react-bootstrap';
import type { SendMode } from '../../../../apps/hooks/push-notification/usePushNotification';

interface SendConfirmModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
  isSending: boolean;
  sendMode: SendMode;
  title: string;
  body: string;
  receiverIdentifier?: string;
}

export const SendConfirmModal = ({
  show,
  onHide,
  onConfirm,
  isSending,
  sendMode,
  title,
  body,
  receiverIdentifier,
}: SendConfirmModalProps) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Send Push Notification</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          {sendMode === 'all' ? (
            <strong className="text-danger">You are about to send a push notification to ALL registered devices.</strong>
          ) : (
            <>
              Sending push notification to user: <strong>{receiverIdentifier}</strong>
            </>
          )}
        </p>
        <div className="border rounded p-3 bg-light">
          <div className="mb-1">
            <strong>Title:</strong> {title}
          </div>
          <div>
            <strong>Body:</strong> {body}
          </div>
        </div>
        {sendMode === 'all' && (
          <p className="text-muted mt-3 mb-0" style={{ fontSize: '14px' }}>
            This action cannot be undone. Please double-check the notification content before sending.
          </p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={isSending}>
          Cancel
        </Button>
        <Button variant={sendMode === 'all' ? 'danger' : 'primary'} onClick={onConfirm} disabled={isSending}>
          {isSending ? 'Sending...' : sendMode === 'all' ? 'Send to All' : 'Send'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
